import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";

import r1 from "../../Images/rec/11.webp";
import r2 from "../../Images/rec/14.webp";
import r3 from "../../Images/rec/15.webp";
import r4 from "../../Images/rec/16.webp";
import r5 from "../../Images/rec/17.webp";
import r6 from "../../Images/rec/18.webp";
import r7 from "../../Images/rec/19.webp";
import r8 from "../../Images/rec/nsdc.webp";
import r9 from "../../Images/rec/aacsb.webp";
import r10 from "../../Images/accrediations/Naac.webp";

const recognitions = [
  {
    img: r10,
    alt: "Chhattisgarh Shasan Recognition",
    text: "Recognized by NAAC for academic excellence and quality education in India.",
  },
  {
    img: r1,
    alt: "Chhattisgarh Shasan Recognition",
    text: "A Chhattisgarh Shasan recognized university ensures that your degree is officially validated, boosting your career prospects and credibility.",
  },
  {
    img: r2,
    alt: "UGC-Recognized University",
    text: "A UGC-recognized university ensures your degree is nationally accredited, enhancing its value and your opportunities for higher education and employment.",
  },
  {
    img: r3,
    alt: "AICTE-recognized University",
    text: "An AICTE-recognized university guarantees that your technical education meets national standards, increasing your employability in the engineering and technology sectors.",
  },
  {
    img: r4,
    alt: "CGPURC-recognized University",
    text: "A CGPURC-recognized university ensures your degree is approved by the Chhattisgarh government, providing legitimacy and value to your educational qualifications within the state.",
  },
  {
    img: r5,
    alt: "Bar Council of India-recognized University",
    text: "A Bar Council of India-recognized university ensures that your law degree is accredited, allowing you to practice law professionally across India.",
  },
  {
    img: r6,
    alt: "AIU-recognized University",
    text: "An AIU-recognized university ensures your degree is equivalent to those from other accredited universities, facilitating seamless higher education and career opportunities both in India and abroad.",
  },
  {
    img: r7,
    alt: "Pharmacy Council-recognized University",
    text: "A Pharmacy Council-recognized university ensures your pharmacy degree is accredited, qualifying you to practice as a licensed pharmacist in India.",
  },
  {
    img: r8,
    alt: "NSDC-recognized University",
    text: "A NSDC-recognized university equips you with industry-aligned skills and certifications, enhancing your employability and readiness for the workforce.",
  },
  {
    img: r9,
    alt: "ISBM University Achieves AACSB Membership",
    text: "International Prestige: AACSB membership indicates credibility, and our business programs are recognized and respected worldwide by employers and educational institutions.",
  },
];

const Reccaraousal = () => {
  return (
    <Swiper
      modules={[Autoplay]}
      loop
      speed={1000} // slide transition speed
      autoplay={{ delay: 3000, disableOnInteraction: false }}
      slidesPerView={1}
      spaceBetween={30}
      className="recognition-slider"
    >
      {recognitions.map((rec, idx) => (
        <SwiperSlide key={idx}>
          <div className="recognition-item">
            <div className="recognitionInfo shadow-lg m-auto text-center p-3">
              <img
                src={rec.img}
                alt={rec.alt}
                className="recognitionImg mb-3"
              />
              <p>{rec.text}</p>
            </div>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default Reccaraousal;
